if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
    constructor() {
  super()
  this.videoObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const video = entry.target.querySelector('video.product-video');
      if (!video) return;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
        video.muted = true;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  },
  {
    root: this.querySelector('[role="document"]'),
    threshold: [0, 0.6, 1],
  }
);;

  this.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const video = event.target.closest('video');
    if (!video) return;

    this.hide();
  });
}
hide() {
  super.hide();
}

show(opener) {
  super.show(opener);

  this.querySelectorAll('deferred-media').forEach((media) => {
    media.loadContent(false);
  });

  this.showActiveMedia();

  this.querySelectorAll('deferred-media video').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    video.play().catch(() => {});
  });
}

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        if (!activeMedia) return;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName == 'DEFERRED-MEDIA') {
  activeMedia.loadContent();
}

       const modalVideo = activeMedia.querySelector('video');

if (modalVideo) {
  modalVideo.muted = true;
  modalVideo.defaultMuted = true;
  modalVideo.loop = true;
  modalVideo.playsInline = true;

  modalVideo.setAttribute('muted', '');
  modalVideo.setAttribute('playsinline', '');
  modalVideo.setAttribute('webkit-playsinline', '');
  modalVideo.setAttribute('autoplay', '');

  const playModalVideo = () => {
    modalVideo.play().catch(() => {});
  };

  if (modalVideo.readyState >= 2) {
    playModalVideo();
  } else {
    modalVideo.addEventListener('loadeddata', playModalVideo, { once: true });
    modalVideo.addEventListener('canplay', playModalVideo, { once: true });
  }

  setTimeout(playModalVideo, 100);
  setTimeout(playModalVideo, 500);
}
      }
    }
  );
}
